import { render } from "./ReceitasStatusDropdown.vue?vue&type=template&id=43fa95c5"
import script from "./ReceitasStatusDropdown.vue?vue&type=script&lang=js"
export * from "./ReceitasStatusDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__